import { render, staticRenderFns } from "./TabsHome.vue?vue&type=template&id=1d6e2b5a"
import script from "./TabsHome.vue?vue&type=script&lang=ts"
export * from "./TabsHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports